import React from 'react';
import { Link } from 'react-router-dom';

const formatCurrency = (value) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(Number(value || 0));

const formatDate = (value) => {
  if (!value) return '—';

  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);

  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleDateString('en-IN');
};

const InvoicesTable = ({ invoices, loading, onDownload }) => {
  if (loading) {
    return (
      <div className="invoices-table-state">
        Loading invoices...
      </div>
    );
  }

  if (!invoices.length) {
    return (
      <div className="invoices-table-state">
        <h3>No invoices found</h3>
        <p>Try changing the filters or create your first invoice.</p>
        <Link
          to="/user/invoices/create"
          className="invoice-primary-button"
        >
          Create Invoice
        </Link>
      </div>
    );
  }

  return (
    <div className="invoices-table-wrapper">
      <table className="invoices-table">
        <thead>
          <tr>
            <th>Invoice</th>
            <th>Customer</th>
            <th>Invoice Date</th>
            <th>Due Date</th>
            <th>Total Amount</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {invoices.map((invoice) => (
            <tr key={invoice.id}>
              <td>
                <strong>{invoice.invoice_number}</strong>
              </td>

              <td>
                <strong>{invoice.dealer_name}</strong>
                {invoice.dealer_mobile && (
                  <span className="invoice-cell-secondary">
                    {invoice.dealer_mobile}
                  </span>
                )}
              </td>

              <td>{formatDate(invoice.invoice_date)}</td>
              <td>{formatDate(invoice.due_date)}</td>

              <td className="invoice-amount">
                {formatCurrency(invoice.total_amount)}
              </td>

              <td>
                <span
                  className={`invoice-status invoice-status-${invoice.status}`}
                >
                  {invoice.status}
                </span>
              </td>

              <td>
                <div className="invoice-row-actions">
                  <Link
                    to={`/user/invoices/${encodeURIComponent(
                      invoice.invoice_number
                    )}`}
                    className="invoice-action-link"
                  >
                    View
                  </Link>

                  <button
                    type="button"
                    className="invoice-action-link"
                    onClick={() => onDownload(invoice)}
                  >
                    PDF
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoicesTable;